var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import '../style.scss';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
import SelectFolderInput from '~/components/select_folder_input';
import Input from '~/form_components/text_input';
import { useAppSidebar } from '~/layout/main_layout/app_sidebar/provider';
import { useProjectDocumentComparison } from '../../../providers/project_document_comparison';
const CreateNewProjectForm = (props) => {
    const { onCreateNewFolder, setIsVisible } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [folderName, setFolderName] = useState(undefined);
    const [isInProgress, setIsInProgress] = useState(false);
    const locationRef = useRef(null);
    const { createProject } = useProjectDocumentComparison();
    const { projectsWorkspaces, isArchivedVisible } = useAppSidebar();
    const onFolderSelect = (folder) => {
        setSelectedFolder(folder);
        ToggleFolderExpansion();
    };
    useEffect(() => {
        if (selectedFolder && (locationRef === null || locationRef === void 0 ? void 0 : locationRef.current)) {
            locationRef.current.value = selectedFolder.name;
        }
    }, [selectedFolder]);
    const ToggleFolderExpansion = () => {
        setIsExpanded(!isExpanded);
    };
    const resetUI = () => {
        setIsExpanded(false);
        setSelectedFolder(null);
        setFolderName('');
    };
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (folderName && selectedFolder) {
            setIsInProgress(true);
            const newProject = yield createProject(folderName, selectedFolder.id === 'top-level-option' ? undefined : selectedFolder.id);
            setIsInProgress(false);
            onCreateNewFolder(newProject);
            resetUI();
        }
    });
    const saveButtonClass = classnames({
        'save-btn': !isInProgress,
    });
    return (React.createElement(GeniusModal, { isModalShowing: props.isVisible, onHide: () => { resetUI(); setIsVisible(false); }, headerContent: React.createElement("div", { className: "form-header" }, "Add To Projects"), bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Folder Name' }, "Folder name"),
            React.createElement("div", { className: 'new-folder-during-add-project-input' },
                React.createElement(Input, { name: 'folder name', value: folderName, onChange: (e) => setFolderName(e.target.value), placeholder: 'Enter a folder name' })),
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, "Location"),
            React.createElement(SelectFolderInput, { ToggleFolderExpansion: ToggleFolderExpansion, isExpanded: isExpanded, projectsWorkspaces: projectsWorkspaces, onFolderSelect: onFolderSelect, isArchivedVisible: isArchivedVisible, selectedDisplay: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.name, selectedId: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.id, showTopLevelOption: true })), footerContent: React.createElement(Button, { className: saveButtonClass, primary: true, loading: isInProgress, onClick: handleClick, disabled: !folderName || !selectedFolder }, "Save") }));
};
export default CreateNewProjectForm;
